import * as React from 'react';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';

const ExitRow: React.FunctionComponent = () => {
	const theme = useTheme('SeatMap').SeatMapStyles;
	const { t } = useTranslation('SeatMap');

	return (
		<div className={theme.exit}>
			<div className={theme.exit__label}>{t('SeatMap:Exit')}</div>

			<div className={theme.exit__label}>{t('SeatMap:Exit')}</div>
		</div>
	);
};
export default ExitRow;
